import { Routes } from '@angular/router';
import { AuthGuard } from 'guard/auth.guard';

export const routes: Routes = [
    {
        path: '',
        title: 'Tourbo',
        loadChildren: () => import ('@modules/landing/landing-routing.module').then(module => module.LandingRoutingModule)
    },
    {
        path: 'auth',
        loadChildren: () => import ('@modules/auth/auth-routing.module').then(module => module.AuthRoutingModule)
    },
    {
        path: 'dashboard',
        loadChildren: () => import ('@modules/dashboard/dashboard-routing.module').then(module => module.DashboardRoutingModule),
        canActivate: [AuthGuard]
    },
    {
        path: '**',
        redirectTo: ''
    }
];
